(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soak-region-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'soakRegionPopupDismissed';
    var popup = document.getElementById('soak-region-popup');
    if (!popup) return;

    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (error) {}

    var dismiss = function () {
      popup.hidden = true;
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {}
    };

    popup.hidden = false;
    popup.querySelector('[data-soak-region-accept]').addEventListener('click', dismiss);
    popup.querySelector('[data-soak-region-dismiss]').addEventListener('click', dismiss);
  })();
  } catch(e) { console.error(e); }
})();

})();
